import {observer} from "mobx-react";
import {useStore} from "../../../../../../../hooks";
import Alerts from "../../../../../../../elements/v2/Alerts/Alerts";
import React from "react";
import {MarketingErrorMessages} from "../../../../../../../utils/enums";

export const RedirectSuccessAlert = observer(() => {
  const { marketingStore } = useStore();
  const { alert } = marketingStore;
  
  return (
    <>
      {alert.showRedirectSuccess && (
        <Alerts
          severity={'success'}
          width={"auto"}
          top={"61px"}
          right={"16px"}
          title={MarketingErrorMessages.REDIRECT_MESSAGE_DRAFT_SUCCESS.title}
          message={MarketingErrorMessages.REDIRECT_MESSAGE_DRAFT_SUCCESS.message}
          onClose={() => alert.showOrHide("showRedirectSuccess")}
        />
      )}
    </>
  );
});
